module.exports = __webpack_public_path__ + "static/media/ReportLady.9e7d355c.svg";